import React, { HTMLAttributes, ReactNode } from 'react';
import { styled } from '@mui/material';
import Container from './Container';

export type TabsProps = HTMLAttributes<HTMLDivElement> & {
  tabs: { key: string; title: ReactNode; icon?: ReactNode }[];
  value: string;
  onTabSelect?: (value: string) => void;
};

const TabsContainer = styled(Container)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
}));

const Tab = styled('div')`
  box-sizing: border-box;
  border: solid 1px transparent;
  align-items: center;
  padding: 6px 14px;
  gap: 4px;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: #0747A6;
  cursor: pointer;
  display: flex;
  flex-direction: row;
`;

const SelectedTab = styled(Tab)`
  background-color: #ffffff;
  border: solid 1px #DFE1E6;
  border-radius: 6px;
  color: #091E42;
  cursor: default;
`;


export default ({ tabs, value, onTabSelect, ...props }: TabsProps) => {

  const onSelect = (v: string) => {
    if (onTabSelect) {
      onTabSelect(v);
    }
  };

  return (
  <TabsContainer {...props}>
    {tabs.map((tab) => (
      (tab.key === value)
        ? <SelectedTab key={tab.key}>{tab.icon}{tab.title}</SelectedTab>
        : <Tab key={tab.key} onClick={() => onSelect(tab.key)}>{tab.title}</Tab>
    ))}
  </TabsContainer>
  );
};